import { slugify } from '@aura/components-frontend';
import { useConfig, useToggles } from '@aura/contextos-frontend';
import { useAppEmbarcado } from '@aura/utils-frontend';
import React from 'react';
import { Helmet } from 'react-helmet';

const capitilize = (title: string) => {
  return title.charAt(0).toUpperCase() + title.slice(1);
};

export const Head: React.FC = () => {
  const { getValueOrDefault, brand } = useConfig();
  const srcScriptChatAssistentePessoal = getValueOrDefault<string>('URL_SCRIPT_CHAT_ASSISTENTE_PESSOAL', '');
  const urlAdobeLaunchScript = getValueOrDefault<string>('URL_ADOBE_LAUNCH_SCRIPT', '');

  const { isEnabled } = useToggles();
  const FF_CHAT_ASSISTENTE_PESSOAL_MOBILE = 'CHAT_ASSISTENTE_PESSOAL_MOBILE';
  const FF_ADOBE = 'SAVA_476136';

  const { isAppEmbarcado } = useAppEmbarcado();

  const liberaChatAssistentePessoalApp = isEnabled(FF_CHAT_ASSISTENTE_PESSOAL_MOBILE) && isAppEmbarcado;

  const deveMontarScriptChatAssistentePessoal =
    (liberaChatAssistentePessoalApp || !isAppEmbarcado) && srcScriptChatAssistentePessoal.length && brand === 'estacio';

  const deveMontarScriptAdobe = isEnabled(FF_ADOBE) && urlAdobeLaunchScript;

  return (
    <Helmet>
      <title>{brand && `Sala de Aula | ${capitilize(brand)}`}</title>
      <link
        rel="icon"
        type="image/png"
        href={`${process.env.PUBLIC_URL}/${slugify(brand)}/favicon.ico`}
        sizes="16x16"
      />
      <link rel="manifest" href={`${process.env.PUBLIC_URL}/${slugify(brand)}/manifest.json`} />
      <style type="text/css">
        {`
          [data-lift="lft-tag"] {
            width: fit-content;
          }
       `}
      </style>
      {deveMontarScriptChatAssistentePessoal && <script src={srcScriptChatAssistentePessoal} />}

      {deveMontarScriptAdobe && (
        <script>
          {`
            !(function (e, a, n, t) {
              var i = e.head;
              if (i) {
                if (a) return;
                var o = e.createElement('style');
                (o.id = 'alloy-prehiding'),
                  (o.innerText = n),
                  i.appendChild(o),
                  setTimeout(function () {
                    o.parentNode && o.parentNode.removeChild(o);
                  }, t);
              }
            })(
              document,
              document.location.href.indexOf('adobe_authoring_enabled') !== -1,
              '.personalization-container { opacity: 0 !important }',
              3000
            );
          `}
        </script>
      )}
      {deveMontarScriptAdobe && <script src={`${urlAdobeLaunchScript}`} async></script>}
    </Helmet>
  );
};
